// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "feature_flag.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "feature_flag.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf enum FlagState
 */
export var FlagState;
(function (FlagState) {
    /**
     * @generated from protobuf enum value: FLAG_STATE_OFF = 0;
     */
    FlagState[FlagState["OFF"] = 0] = "OFF";
    /**
     * @generated from protobuf enum value: FLAG_STATE_ON = 1;
     */
    FlagState[FlagState["ON"] = 1] = "ON";
})(FlagState || (FlagState = {}));
// @generated message type with reflection information, may provide speed optimized methods
class FeatureFlag$Type extends MessageType {
    constructor() {
        super("FeatureFlag", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["FlagState", FlagState, "FLAG_STATE_"] },
            { no: 3, name: "enabled_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "keep_until", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "keep_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "retired_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "updated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "owner_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        message.state = 0;
        message.enabledAt = "";
        message.keepUntil = "";
        message.keepReason = "";
        message.retiredAt = "";
        message.updatedBy = 0;
        message.updatedAt = "";
        message.ownerUserIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* FlagState state */ 2:
                    message.state = reader.int32();
                    break;
                case /* string enabled_at */ 3:
                    message.enabledAt = reader.string();
                    break;
                case /* string keep_until */ 4:
                    message.keepUntil = reader.string();
                    break;
                case /* string keep_reason */ 5:
                    message.keepReason = reader.string();
                    break;
                case /* string retired_at */ 6:
                    message.retiredAt = reader.string();
                    break;
                case /* int32 updated_by */ 7:
                    message.updatedBy = reader.int32();
                    break;
                case /* string updated_at */ 8:
                    message.updatedAt = reader.string();
                    break;
                case /* repeated int32 owner_user_ids */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ownerUserIds.push(reader.int32());
                    else
                        message.ownerUserIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* FlagState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        /* string enabled_at = 3; */
        if (message.enabledAt !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.enabledAt);
        /* string keep_until = 4; */
        if (message.keepUntil !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.keepUntil);
        /* string keep_reason = 5; */
        if (message.keepReason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.keepReason);
        /* string retired_at = 6; */
        if (message.retiredAt !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.retiredAt);
        /* int32 updated_by = 7; */
        if (message.updatedBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.updatedBy);
        /* string updated_at = 8; */
        if (message.updatedAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.updatedAt);
        /* repeated int32 owner_user_ids = 9; */
        if (message.ownerUserIds.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ownerUserIds.length; i++)
                writer.int32(message.ownerUserIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FeatureFlag
 */
export const FeatureFlag = new FeatureFlag$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FlagDefinition$Type extends MessageType {
    constructor() {
        super("FlagDefinition", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tickets", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "cleanup_after_days", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        message.description = "";
        message.tickets = [];
        message.createdAt = "";
        message.cleanupAfterDays = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated string tickets */ 3:
                    message.tickets.push(reader.string());
                    break;
                case /* string created_at */ 4:
                    message.createdAt = reader.string();
                    break;
                case /* int32 cleanup_after_days */ 5:
                    message.cleanupAfterDays = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated string tickets = 3; */
        for (let i = 0; i < message.tickets.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.tickets[i]);
        /* string created_at = 4; */
        if (message.createdAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdAt);
        /* int32 cleanup_after_days = 5; */
        if (message.cleanupAfterDays !== 0)
            writer.tag(5, WireType.Varint).int32(message.cleanupAfterDays);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FlagDefinition
 */
export const FlagDefinition = new FlagDefinition$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeatureFlagList$Type extends MessageType {
    constructor() {
        super("FeatureFlagList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FeatureFlag },
            { no: 2, name: "backend_definitions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FlagDefinition },
            { no: 3, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.backendDefinitions = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FeatureFlag results */ 1:
                    message.results.push(FeatureFlag.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated FlagDefinition backend_definitions */ 2:
                    message.backendDefinitions.push(FlagDefinition.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 3:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FeatureFlag results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FeatureFlag.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated FlagDefinition backend_definitions = 2; */
        for (let i = 0; i < message.backendDefinitions.length; i++)
            FlagDefinition.internalBinaryWrite(message.backendDefinitions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 3; */
        if (message.totalCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FeatureFlagList
 */
export const FeatureFlagList = new FeatureFlagList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFlagRequest$Type extends MessageType {
    constructor() {
        super("SetFlagRequest", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["FlagState", FlagState, "FLAG_STATE_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        message.state = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* FlagState state */ 2:
                    message.state = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* FlagState state = 2; */
        if (message.state !== 0)
            writer.tag(2, WireType.Varint).int32(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetFlagRequest
 */
export const SetFlagRequest = new SetFlagRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeepFlagRequest$Type extends MessageType {
    constructor() {
        super("KeepFlagRequest", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "keep_until", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "keep_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        message.keepUntil = "";
        message.keepReason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string keep_until */ 2:
                    message.keepUntil = reader.string();
                    break;
                case /* string keep_reason */ 3:
                    message.keepReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string keep_until = 2; */
        if (message.keepUntil !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.keepUntil);
        /* string keep_reason = 3; */
        if (message.keepReason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.keepReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message KeepFlagRequest
 */
export const KeepFlagRequest = new KeepFlagRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFlagOwnersRequest$Type extends MessageType {
    constructor() {
        super("SetFlagOwnersRequest", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "owner_user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        message.ownerUserIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* repeated int32 owner_user_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.ownerUserIds.push(reader.int32());
                    else
                        message.ownerUserIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* repeated int32 owner_user_ids = 2; */
        if (message.ownerUserIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.ownerUserIds.length; i++)
                writer.int32(message.ownerUserIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetFlagOwnersRequest
 */
export const SetFlagOwnersRequest = new SetFlagOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFlagChangesRequest$Type extends MessageType {
    constructor() {
        super("ListFlagChangesRequest", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.key = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ListFlagChangesRequest
 */
export const ListFlagChangesRequest = new ListFlagChangesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeatureFlagChange$Type extends MessageType {
    constructor() {
        super("FeatureFlagChange", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "flag_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "action", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "from_state", kind: "enum", T: () => ["FlagState", FlagState, "FLAG_STATE_"] },
            { no: 5, name: "to_state", kind: "enum", T: () => ["FlagState", FlagState, "FLAG_STATE_"] },
            { no: 6, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "changed_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "changed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.flagKey = "";
        message.action = "";
        message.fromState = 0;
        message.toState = 0;
        message.detail = "";
        message.changedBy = 0;
        message.changedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string flag_key */ 2:
                    message.flagKey = reader.string();
                    break;
                case /* string action */ 3:
                    message.action = reader.string();
                    break;
                case /* FlagState from_state */ 4:
                    message.fromState = reader.int32();
                    break;
                case /* FlagState to_state */ 5:
                    message.toState = reader.int32();
                    break;
                case /* string detail */ 6:
                    message.detail = reader.string();
                    break;
                case /* int32 changed_by */ 7:
                    message.changedBy = reader.int32();
                    break;
                case /* string changed_at */ 8:
                    message.changedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string flag_key = 2; */
        if (message.flagKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.flagKey);
        /* string action = 3; */
        if (message.action !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.action);
        /* FlagState from_state = 4; */
        if (message.fromState !== 0)
            writer.tag(4, WireType.Varint).int32(message.fromState);
        /* FlagState to_state = 5; */
        if (message.toState !== 0)
            writer.tag(5, WireType.Varint).int32(message.toState);
        /* string detail = 6; */
        if (message.detail !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.detail);
        /* int32 changed_by = 7; */
        if (message.changedBy !== 0)
            writer.tag(7, WireType.Varint).int32(message.changedBy);
        /* string changed_at = 8; */
        if (message.changedAt !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.changedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FeatureFlagChange
 */
export const FeatureFlagChange = new FeatureFlagChange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FeatureFlagChangeList$Type extends MessageType {
    constructor() {
        super("FeatureFlagChangeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FeatureFlagChange },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated FeatureFlagChange results */ 1:
                    message.results.push(FeatureFlagChange.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated FeatureFlagChange results = 1; */
        for (let i = 0; i < message.results.length; i++)
            FeatureFlagChange.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FeatureFlagChangeList
 */
export const FeatureFlagChangeList = new FeatureFlagChangeList$Type();
/**
 * @generated ServiceType for protobuf service FeatureFlagService
 */
export const FeatureFlagService = new ServiceType("FeatureFlagService", [
    { name: "ListFlags", options: {}, I: Empty, O: FeatureFlagList },
    { name: "SetFlag", options: {}, I: SetFlagRequest, O: FeatureFlag },
    { name: "KeepFlag", options: {}, I: KeepFlagRequest, O: FeatureFlag },
    { name: "SetFlagOwners", options: {}, I: SetFlagOwnersRequest, O: FeatureFlag },
    { name: "ListFlagChanges", options: {}, I: ListFlagChangesRequest, O: FeatureFlagChangeList }
]);
